(() => {
  const cart = document.querySelector('cart-items');
  if (!cart) return;
  let frame;
  cart.classList.add('gp-preview-enhanced');
  // Delegate to the current row so app-injected links and refreshed cart lines work too.
  cart.addEventListener('click', event => {
    const media = event.target.closest('.cart-item__media');
    if (!media || event.target.closest('.gp-cart-preview')) return;
    const row = media.closest('.cart-item');
    const original = row?.querySelector('.cart-item__details .tee-preview-button');
    if (!original && row?.dataset.hasPreview !== 'true') return;
    event.preventDefault();
    event.stopPropagation();
    if (!original) return;
    media.querySelector('.gp-cart-preview')?.focus({ preventScroll: true });
    original.click();
  }, true);
  function refresh() {
    frame = null;
    cart.querySelectorAll('.cart-item').forEach(row => {
      const original = row.querySelector('.cart-item__details .tee-preview-button');
      const media = row.querySelector('.cart-item__image-container');
      let button = media?.querySelector('.gp-cart-preview');
      const img = media?.querySelector('img');
      if ((!original && row.dataset.hasPreview !== 'true') || !img) {
        button?.remove();
        row.classList.remove('gp-cart-has-preview');
        return;
      }
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'gp-cart-preview';
        button.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6M10 7v6M7 10h6"/></svg><span>Preview</span>';
        button.addEventListener('click', () => button.closest('.cart-item')?.querySelector('.cart-item__details .tee-preview-button')?.click());
        media.append(button);
      }
      button.disabled = !original;
      button.setAttribute('aria-label', original ? 'Preview design' : 'Loading preview');
      row.classList.add('gp-cart-has-preview');
    });
  }
  new MutationObserver(() => {
    if (!frame) frame = requestAnimationFrame(refresh);
  }).observe(cart, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  refresh();
})();
